import React from 'react';
import { haptic } from '../../utils/haptics';
import styles from './agentChat.module.css';

/**
 * WHAT THE CONVERSATION IS ABOUT (round 2, as the portal's FocusBar). A card's "?" makes it the subject: a chip
 * "About <name> ×" above the composer, and the questions a customer asks about it, sent through the chat like any
 * message. A product is also carried by every send as the one the shopper is looking at (agentPageContext `focus` →
 * page.productId / productName), so "it" means it; a service or a place for rent (owner 10-23) is not a page the
 * server reads, so its questions name it.
 */
export const FOLLOW_UPS = [
  ['agent.aboutStock', 'Is it in stock?'],
  ['agent.aboutOptions', 'What sizes or options does it have?'],
  ['agent.aboutMore', 'Tell me more about it'],
];
const BY_KIND = {
  product: FOLLOW_UPS,
  service: [
    ['agent.aboutServicePrice', 'How much is {{name}}?'],
    ['agent.aboutServiceLength', 'How long does {{name}} take?'],
    ['agent.aboutServiceWho', 'Who does {{name}}?'],
  ],
  stay: [
    ['agent.aboutStayPrice', 'How much is a night at {{name}}?'],
    ['agent.aboutStayGuests', 'How many guests can stay at {{name}}?'],
    ['agent.aboutStayRules', 'What are the house rules at {{name}}?'],
  ],
};

export default function FocusBar({ focus, onSend, onClear, disabled = false, t }) {
  if (!focus) return null;
  const stop = t('agent.aboutStop', { defaultValue: 'Stop asking about {{name}}', name: focus.name });
  const questions = BY_KIND[focus.kind] || FOLLOW_UPS;
  return (
    <div className={styles.focusBar} data-testid="agent-focus-bar">
      <div className={styles.focusChip}>
        <span className={styles.focusChipLabel}>{t('agent.aboutLabel', { defaultValue: 'About' })}</span>
        <span className={styles.focusChipName}>{focus.name}</span>
        <button type="button" className={styles.focusChipClear} onClick={onClear} aria-label={stop}>×</button>
      </div>
      <div className={styles.focusQuestions}>
        {questions.map(([key, defaultValue]) => {
          const label = t(key, { defaultValue, name: focus.name });
          return (
            <button key={key} type="button" className={styles.focusQuestion} disabled={disabled} onClick={() => { haptic('selection'); onSend(label, { via: 'choice' }); }}>
              {label}
            </button>
          );
        })}
      </div>
    </div>
  );
}
